import { render } from "./AppDropdownPartitionTitle.vue?vue&type=template&id=0863c8f6"
import script from "./AppDropdownPartitionTitle.vue?vue&type=script&lang=js"
export * from "./AppDropdownPartitionTitle.vue?vue&type=script&lang=js"

import "./AppDropdownPartitionTitle.vue?vue&type=style&index=0&id=0863c8f6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__